export enum PenaltyDescriptionId {
  C_RATE_HIGH = 'C_RATE_HIGH',
  C_RATE_LOW = 'C_RATE_LOW',
  CURRENT_HIGH = 'CURRENT_HIGH',
  CURRENT_LOW = 'CURRENT_LOW',
  DOD_HIGH_CHA = 'DOD_HIGH_CHA',
  DOD_HIGH_DCH = 'DOD_HIGH_DCH',
  POWER_HIGH_AVG = 'POWER_HIGH_AVG',
  POWER_HIGH_PEAK = 'POWER_HIGH_PEAK',
  POWER_HIGH = 'POWER_HIGH',
  POWER_LOW = 'POWER_LOW',
  SOC_HIGH = 'SOC_HIGH',
  SOC_LOW = 'SOC_LOW',
  RSOC_HIGH = 'RSOC_HIGH',
  TEMPERATURE_HIGH_CHA = 'TEMPERATURE_HIGH_CHA',
  TEMPERATURE_HIGH_DCH = 'TEMPERATURE_HIGH_DCH',
  TEMPERATURE_HIGH = 'TEMPERATURE_HIGH',
  TEMPERATURE_LOW_CHA = 'TEMPERATURE_LOW_CHA',
  TEMPERATURE_LOW_DCH = 'TEMPERATURE_LOW_DCH',
  TEMPERATURE_LOW = 'TEMPERATURE_LOW',
  TP_HIGH_DCH = 'TP_HIGH_DCH',
  VOLTAGE_HIGH = 'VOLTAGE_HIGH',
  VOLTAGE_LOW = 'VOLTAGE_LOW',
}

/**
 * Human-readable labels for each penalty description coming from Looker.
 * Keep in sync with platform_core_warranty_penalty_unit_alerts.view.lkml.tmp.
 */
export const PenaltyDescriptionLabel: Record<PenaltyDescriptionId, string> = {
  [PenaltyDescriptionId.C_RATE_HIGH]: 'High C-rate during charge',
  [PenaltyDescriptionId.C_RATE_LOW]: 'High C-rate during discharge',
  [PenaltyDescriptionId.CURRENT_HIGH]: 'High current during charge',
  [PenaltyDescriptionId.CURRENT_LOW]: 'High current during discharge',
  [PenaltyDescriptionId.DOD_HIGH_CHA]: 'High DOD during charge',
  [PenaltyDescriptionId.DOD_HIGH_DCH]: 'High DOD during discharge',
  [PenaltyDescriptionId.POWER_HIGH_AVG]: 'High average power',
  [PenaltyDescriptionId.POWER_HIGH_PEAK]: 'High peak power',
  [PenaltyDescriptionId.POWER_HIGH]: 'High power during charge',
  [PenaltyDescriptionId.POWER_LOW]: 'High power during discharge',
  [PenaltyDescriptionId.SOC_HIGH]: 'High state of charge',
  [PenaltyDescriptionId.SOC_LOW]: 'Low state of charge',
  [PenaltyDescriptionId.RSOC_HIGH]: 'High resting state of charge',
  [PenaltyDescriptionId.TEMPERATURE_HIGH_CHA]: 'High temperature during charge',
  [PenaltyDescriptionId.TEMPERATURE_HIGH_DCH]:
    'High temperature during discharge',
  [PenaltyDescriptionId.TEMPERATURE_HIGH]: 'High temperature',
  [PenaltyDescriptionId.TEMPERATURE_LOW_CHA]: 'Low temperature during charge',
  [PenaltyDescriptionId.TEMPERATURE_LOW_DCH]:
    'Low temperature during discharge',
  [PenaltyDescriptionId.TEMPERATURE_LOW]: 'Low temperature',
  [PenaltyDescriptionId.TP_HIGH_DCH]: 'High discharge throughput',
  [PenaltyDescriptionId.VOLTAGE_HIGH]: 'High voltage',
  [PenaltyDescriptionId.VOLTAGE_LOW]: 'Low voltage',
};
